var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-container",class:{
      'page-unloaded': !_vm.isPageLoaded
    }},[_vm._t("default")],2),(!_vm.isPageLoaded)?_c('loading-bar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }